import type { AppProps, NextWebVitalsMetric } from "next/app"
import { ApolloProvider } from "@apollo/client"

import { GameProvider, GameController } from "context/Game/Game"
import Web3Provider from "context/Web3Provider"
import Layout from "layout/Layout"
import { DefaultSEO } from "@hfc/shared/components/SEO/SEO"
import { GoogleTagManagerIframe } from "@hfc/shared/components/SEO/GoogleTagManager"

import { useApollo } from "utils/apolloClient"
import isProduction from "@hfc/shared/utils/isProduction"

// Tailwind
import "@hfc/shared/styles/globals.css"
import "@hfc/shared/styles/howdy-games.css"

const Game = ({ Component, pageProps }: AppProps) => {
	const apolloClient = useApollo(pageProps)

	return (
		<ApolloProvider client={apolloClient}>
			<Web3Provider>
				<GameProvider>
					<GameController />

					<DefaultSEO
						asPath="/"
						title="Howdy Games Metaverse | Play-to-earn Polygon NFT"
					/>
					<GoogleTagManagerIframe
						containerId={
							process.env
								.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_CONTAINER_ID
						}
					/>

					<Layout>
						<Component {...pageProps} />
					</Layout>
				</GameProvider>
			</Web3Provider>
		</ApolloProvider>
	)
}

export function reportWebVitals(metric: NextWebVitalsMetric) {
	if (isProduction()) console.info(metric)
}

export default Game
